import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import 'react-datepicker/dist/react-datepicker.css';
import { colorText, colorAccent, colorFieldsBorder } from '@/utils/palette';
import { CalendarBlankIcon } from '@/shared/dynamicImports';
import { formatDate } from './utils';
import { DatePickerWrap } from './DatePickerElements';
import dayjs from 'dayjs';

const DatePickerField = React.memo(
  ({
    name,
    label = 'Select Date',
    defaultValue,
    onChange,
    error,
    dateOutputFormat = 'format3',
    helperText,
    minDate = null,
  }) => {
    const [selectedDate, setSelectedDate] = useState(convertToCorrectInputFormat(defaultValue) || null);
    const [calendarOpen, setCalendarOpen] = useState(false);

    useEffect(() => {
      setSelectedDate(convertToCorrectInputFormat(defaultValue) || null);
    }, [defaultValue]);

    function convertToCorrectInputFormat(dateString) {
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        // If in YYYY-MM-DD format, append "T08:00"
        return `${dateString}T08:00`; // Append "T08:00"
      } else {
        return dateString;
      }
    }

    const handleChange = (dateString) => {
      let formattedDate = formatDate(dateString, dateOutputFormat);
      setSelectedDate(dateString);
      onChange(formattedDate);
    };

    const handleCalendarIconClick = () => {
      setCalendarOpen((prevState) => !prevState);
    };

    const handleDatePickerClick = () => {
      setCalendarOpen(true);
    };

    return (
      <div>
        {label && <Label error={error}>{label}</Label>}
        <DatePickerContainer>
          <DatePickerWrap>
            <StyledDatePicker
              name={name}
              selected={selectedDate}
              onChange={handleChange}
              dateFormat='MM/dd/yyyy'
              open={calendarOpen}
              onClickOutside={() => setCalendarOpen(false)}
              onClick={handleDatePickerClick}
              onFocus={handleDatePickerClick}
              minDate={dayjs(minDate).toDate()}
            />
          </DatePickerWrap>

          <StyledCalendarIcon onClick={handleCalendarIconClick}>
            <CalendarBlankIcon />
          </StyledCalendarIcon>
        </DatePickerContainer>
        {helperText && <HelperText>{helperText}</HelperText>}
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </div>
    );
  },
);

DatePickerField.displayName = 'DatePickerField';

export default DatePickerField;

const HelperText = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${colorText};
`;

const Label = styled.div`
  font-size: 12px;
  margin-top: 6px;
  color: ${(props) => (props.error ? 'red' : colorText)};
`;

const ErrorMessage = styled.div`
  color: red;
  margin-bottom: 20px;
  font-size: 12px;
`;

const DatePickerContainer = styled.div`
  display: flex;
  align-items: center;
  // gap: 8px;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

const StyledCalendarIcon = styled.div`
  cursor: pointer;
  font-size: 16px;
  color: #6c757d;
  border: 1px solid ${colorFieldsBorder};
  // border-radius: 2px;
  height: 32px;
  padding: 2px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

const StyledDatePicker = styled(DatePicker)`
  outline: none;
  width: 100%;
  // height: 28px;
  padding: 5px 12px;
  font-size: 12px;
  border: 1px solid ${colorFieldsBorder};
  // border-radius: 2px;
  background-color: transparent !important;
  color: ${colorText};

  // &:focus {
  //   outline: none;
  //   border-color: ${colorAccent} !important;
  // }

  // &::placeholder {
  //   color: #999;
  // }

  // .react-datepicker__input-container {
  //   width: 100%;
  // }

  // .react-datepicker__day--selected,
  // .react-datepicker__day--keyboard-selected {
  //   background-color: ${colorAccent} !important;
  //   color: #fff;
  // }

  // .react-datepicker__header {
  //   background-color: #f8f9fa;
  //   border-bottom: 1px solid #e9ecef;
  // }

  // .react-datepicker__day {
  //   &:hover {
  //     background-color: ${colorAccent} !important;
  //     color: #fff;
  //   }
  }

  // .react-datepicker__close-icon {
  //   background-color: transparent;
  //   &:after {
  //     background-color: ${colorAccent} !important;
  //     color: white;
  //     border-radius: 50%;
  //   }
  // }
`;
